module.exports = __webpack_public_path__ + "static/media/bg_survey.19a79e60.jpg";